import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import SelectWithNumber from "../../select-number";

export const SelectWithNumberFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <SelectWithNumber
      campo={campo}
      modo={modo}
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      apenasLeitura={campo.apenasLeitura || false}
      onBlur={() => handleBlur(campo)}
      hasError={!!errors[campo.nome]}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
